import AbstractApiService from 'src/services/abstractApiService';
import { DOC2API_URL } from 'pages/APIs';
export default class MagicLinkApiService extends AbstractApiService {
  public constructor() {
    super({});
  }

  public async sendMagicLink(data: any): Promise<any> {
    const formData = new FormData();
    formData.append('org_name', data.org_name);
    formData.append('supplier_type', data.supplier_type);
    formData.append('responder_first_name', data.responder_first_name);
    formData.append('responder_name', data.responder_name);
    formData.append('responder_email', data.responder_email);
    if (data.additional_data) {
      formData.append('additional_data', JSON.stringify(data.additional_data));
    }
    if (data.erp_supplier_id) {
      formData.append('erp_supplier_id', data.erp_supplier_id);
    }
    if (data.supplier_lookup_record_id) {
      formData.append(
        'supplier_lookup_record_id',
        data.supplier_lookup_record_id,
      );
    }
    if (data.existing_id) {
      formData.append('existing_id', data.existing_id);
    }
    return super.post(`${DOC2API_URL}/supplier/send_magic_link`, formData);
  }
}
